import React from 'react';
import { Modal } from '../../../../Smart/Modal/Modal';
import { Button } from '../../../../Form/Button/Button';
import { buttonColors } from '../../../../Pickers/InputTheme';
import { i18n } from '../../../../../Utils/i18n/i18n';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import './OrganizationAssignmentWarningModal.scss';

/**
 * Modal component that warns admins when they try to save a SignDoc without assigning it to any organizations
 *
 * @param {object} props - Component props
 * @param {boolean} props.open - Whether the modal is open
 * @param {Function} props.onClose - Function called when modal is closed/cancelled
 * @param {Function} props.onConfirm - Function called when user confirms they want to save without organization assignment
 * @returns {JSX.Element} - The OrganizationAssignmentWarningModal component
 */
export const OrganizationAssignmentWarningModal = ({
    open,
    onClose,
    onConfirm
}) => {
    if (!open) return null;

    return (
        <Modal open={open} onClose={onClose}>
            <div className="OrganizationAssignmentWarningModal modalWrapper">
                <div className="modalTitle">
                    <WarningAmberIcon className="warningIcon" />
                    <span>{i18n.translate('signDoc.organizationAssignmentWarning.title')}</span>
                </div>

                <div className="modalContent">
                    <div className="warningMessage">
                        {i18n.translate('signDoc.organizationAssignmentWarning.message')}
                    </div>
                    <div className="warningSubMessage">
                        {i18n.translate('signDoc.organizationAssignmentWarning.subMessage')}
                    </div>
                </div>

                <div className="modalFooter">
                    <Button
                        color={buttonColors.GREY}
                        onClick={onClose}
                        text={i18n.translate('signDoc.organizationAssignmentWarning.goBack')}
                        type="button"
                        component="button"
                        disabled={false}
                        style={{}}
                        className=""
                        size={null}
                        icon={null}
                        iconRight={false}
                        variant="contained"
                        loading={false}
                        actionSucceeded={null}
                        actionSucceededText={null}
                        actionFailed={null}
                        disableWithoutPermissions={null}
                        hideWithoutPermissions={null}
                        withArrowIcon={false}
                        customRef={null}
                    />
                    <Button
                        color={buttonColors.YELLOW}
                        onClick={onConfirm}
                        text={i18n.translate('signDoc.organizationAssignmentWarning.continueWithoutAssignment')}
                        type="button"
                        component="button"
                        disabled={false}
                        style={{}}
                        className=""
                        size={null}
                        icon={null}
                        iconRight={false}
                        variant="contained"
                        loading={false}
                        actionSucceeded={null}
                        actionSucceededText={null}
                        actionFailed={null}
                        disableWithoutPermissions={null}
                        hideWithoutPermissions={null}
                        withArrowIcon={false}
                        customRef={null}
                    />
                </div>
            </div>
        </Modal>
    );
}; 